const LOCAL_CREATE_CHECKOUT = "http://localhost:5050/create-checkout";

export const getPaymentCreateCheckoutUrl = () => {
  const configured = String(process.env.REACT_APP_PAYMENT_API_URL || "").trim();
  if (configured) return configured;

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host !== "localhost" && host !== "127.0.0.1") {
      return `${window.location.origin}/payment-api/create-checkout`;
    }
  }

  return LOCAL_CREATE_CHECKOUT;
};

export const getPaymentServiceBase = () => {
  const checkoutUrl = getPaymentCreateCheckoutUrl();
  return checkoutUrl.replace(/\/create-checkout\/?$/, "") || "http://localhost:5050";
};
